import { notificationBaseApi } from './baseSplit';

const accountEndPoints = notificationBaseApi.injectEndpoints({
    endpoints: (build) => ({
        resolveNotification: build.mutation({
            query: (request) => ({
                url: 'ResolveNotification',
                method: 'POST',
                body: request,
            }),
        }),
        closeNotification: build.mutation({
            query: (request) => ({
                url: 'CloseNotification',
                method: 'POST',
                body: request,
            }),
        }),
    }),
    overrideExisting: false,
});

export const { useResolveNotificationMutation, useCloseNotificationMutation } = accountEndPoints;
